{
  "live_ops": "Live Ops",
  "governance": "Governance",
  "lab": "Lab",
  "overview": "Overview",
  "anomalies": "Anomalies · flows",
  "flows": "Flows",
  "incidents": "Incidents · sources",
  "novelty_candidates": "Novelty candidates",
  "campaigns": "Campaigns · clusters",
  "model_health": "Model Health",
  "cost_budget": "Cost / Risk",
  "suppression_suggestions": "Suppression Hints",
  "topology": "Topology",
  "shadow_mode": "Shadow Mode",
  "honey_traps": "Honey Traps",
  "war_mode": "War Mode",
  "models": "Models",
  "trusted": "Trusted",
  "baselines": "Baselines",
  "thresholds": "Thresholds",
  "fleet_shifts": "Fleet Shift",
  "host_baseline_policy": "Baseline Policy",
  "judge_config": "Judges",
  "shadow_review": "Shadow Review",
  "probe_setup": "Probe Setup",
  "post_quantum": "Post-Quantum",
  "wasm_inference": "WASM Inference",
  "entropy": "Entropy",
  "red_team": "Red Team",
  "sbom": "SBOM",
  "federated": "Federated",
  "arbiter": "Arbiter",
  "users": "Users"
}
